import React from 'react';
import './Model.css';

export default ({ sizes, names, match }) => {
  const { firstName, lastName } = names;
  const pSizes = Object.entries(sizes).map(([k, v]) => (
    v ? (
      <p className="modelpage_header_model_info_size" key={k}>
        {`${k?.replace('_', ' ')}: ${v}`}
      </p>)
    : null
  ))
  const name = lastName ? `${firstName} ${lastName}` : firstName;
  return (
    <div className="modelpage_header_model_info">
      <div className="modelpage_header_model_info_name" style={{bottom: match.params.type === 'artists' ? '4px' : '17px'}}>
        {name}
      </div>
      <div className="modelpage_header_model_info_sizes">
        {pSizes}
      </div>
    </div>
  );
};
